import {i18n} from "../i18n/i18n"

export enum ScholasticProduct {
    SCHOLASTIC = "SCHOLASTIC",
    HE_SCHOLASTIC = "HE_SCHOLASTIC",

    MENU = "MENU",
    HE_MENU = "HE_MENU",
    BUSINESS_MENU = "BUSINESS_MENU",

    ATHLETIC = "ATHLETIC",
    HE_ATHLETIC = "HE_ATHLETIC",

    COMMUNITY = "COMMUNITY",
    HE_COMMUNITY = "HE_COMMUNITY",

    CLASSROOM = "CLASSROOM",
    HE_CLASSROOM = "HE_CLASSROOM",
    BUSINESS_CLASSROOM = "BUSINESS_CLASSROOM",

    BUSINESS = "BUSINESS",
}

export const scholasticProductSortIndex: {[p in ScholasticProduct]: number} = {
    [ScholasticProduct.CLASSROOM]: 0,
    [ScholasticProduct.HE_CLASSROOM]: 0,
    [ScholasticProduct.BUSINESS_CLASSROOM]: 0,

    [ScholasticProduct.BUSINESS]: 1,
    [ScholasticProduct.SCHOLASTIC]: 1,
    [ScholasticProduct.HE_SCHOLASTIC]: 1,

    [ScholasticProduct.MENU]: 2,
    [ScholasticProduct.HE_MENU]: 2,
    [ScholasticProduct.BUSINESS_MENU]: 2,

    [ScholasticProduct.ATHLETIC]: 3,
    [ScholasticProduct.HE_ATHLETIC]: 3,

    [ScholasticProduct.COMMUNITY]: 4,
    [ScholasticProduct.HE_COMMUNITY]: 4,
}

export const getScholasticProductView = () => ({
    [ScholasticProduct.SCHOLASTIC]: i18n.t("glossary:product.campus_school"),
    [ScholasticProduct.MENU]: i18n.t("glossary:product.cafeteria_school"),
    [ScholasticProduct.ATHLETIC]: i18n.t("glossary:product.athletic_school"),
    [ScholasticProduct.COMMUNITY]: i18n.t("glossary:product.community_school"),
    [ScholasticProduct.CLASSROOM]: i18n.t("glossary:product.classroom_school"),
    [ScholasticProduct.HE_SCHOLASTIC]: i18n.t("glossary:product.campus_higher_ed"),
    [ScholasticProduct.HE_MENU]: i18n.t("glossary:product.cafeteria_higher_ed"),
    [ScholasticProduct.HE_ATHLETIC]: i18n.t("glossary:product.athletic_higher_ed"),
    [ScholasticProduct.HE_COMMUNITY]: i18n.t("glossary:product.community_higher_ed"),
    [ScholasticProduct.HE_CLASSROOM]: i18n.t("glossary:product.classroom_higher_ed"),
    [ScholasticProduct.BUSINESS]: i18n.t("glossary:product.business"),
    [ScholasticProduct.BUSINESS_MENU]: i18n.t("glossary:product.cafeteria_business"),
    [ScholasticProduct.BUSINESS_CLASSROOM]: i18n.t("glossary:product.workspace"),
})

export const getScholasticVirtualProductView = () => ({
    [ScholasticProduct.SCHOLASTIC]: i18n.t("glossary:product_virtual.campus_school"),
    [ScholasticProduct.MENU]: i18n.t("glossary:product_virtual.cafeteria_school"),
    [ScholasticProduct.ATHLETIC]: i18n.t("glossary:product_virtual.athletic_school"),
    [ScholasticProduct.COMMUNITY]: i18n.t("glossary:product_virtual.community_school"),
    [ScholasticProduct.CLASSROOM]: i18n.t("glossary:product_virtual.classroom_school"),
    [ScholasticProduct.HE_SCHOLASTIC]: i18n.t("glossary:product_virtual.campus_higher_ed"),
    [ScholasticProduct.HE_MENU]: i18n.t("glossary:product_virtual.cafeteria_higher_ed"),
    [ScholasticProduct.HE_ATHLETIC]: i18n.t("glossary:product_virtual.athletic_higher_ed"),
    [ScholasticProduct.HE_COMMUNITY]: i18n.t("glossary:product_virtual.community_higher_ed"),
    [ScholasticProduct.HE_CLASSROOM]: i18n.t("glossary:product_virtual.classroom_higher_ed"),
    [ScholasticProduct.BUSINESS]: i18n.t("glossary:product_virtual.business"),
    [ScholasticProduct.BUSINESS_MENU]: i18n.t("glossary:product_virtual.cafeteria_business"),
    [ScholasticProduct.BUSINESS_CLASSROOM]: i18n.t("glossary:product_virtual.workspace"),
})

export enum RepositoryType {
    CONTENT = "CONTENT",
    THEME = "THEME",
    SAMPLE = "SAMPLE",
    BRAND = "BRAND",
}

export enum MessageIconType {
    DEFAULT = "DEFAULT",
    ADMIN = "ADMIN",
    USERS = "USERS",
    SCREENS = "SCREENS",
    CONTENT = "CONTENT",
    REPOSITORY = "REPOSITORY",
    STUDENT = "STUDENT",
    CREATIVE = "CREATIVE",
    MENU = "MESSAGE_MENU",
}

export enum OtherScholasticProducts {
    BUSINESS = "BUSINESS",
}

export type CommonProductType =
    | ScholasticProduct
    | RepositoryType
    | MessageIconType
    | OtherScholasticProducts

export interface ReachProduct {
    id: string | number
    name: string
    type: CommonProductType
}

export interface IWithProduct {
    product: ReachProduct
}
